export enum EscapeKeyManagerPriority {
  NONE = 0,
  SHEET = 100,
  POPOVER = 200,
}
